import { has } from 'lodash';
import { bus } from '@/utility';
import { gatewayApi } from '@/api';

export default {
  init() {
    window.onParentMessage = (message, payload) => {
      const modifiedData = JSON.stringify(payload);
      const data = JSON.parse(modifiedData);
      bus.$emit(message, data);
    };

    if (window.webkit) {
      /* WKWebView scroll issue */
      document.body.style.overflowY = 'scroll';
    }

    if (this.hasWindowWebAppListener()) {
      this.sendMessage('Slave.Init');
    } else {
      gatewayApi.init();
    }
  },
  sendMessage(message) {
    if (window.webkit) {
      window.webkit.messageHandlers.WebAppListener.postMessage(message);
    } else {
      WebAppListener.sendMessage(message);
    }
  },
  hasWindowWebAppListener() {
    return has(window, 'WebAppListener') || has(window.webkit?.messageHandlers, 'WebAppListener');
  },
  isActive() {
    return navigator.userAgent.includes('wv') || this.isWKWebView();
  },
  isWKWebView() {
    const { userAgent } = window.navigator;

    const isIOS = /iP(hone|od|ad)/.test(userAgent);
    const isWebKit = /WebKit/.test(userAgent);
    const isSafari = /Safari/.test(userAgent);

    return isIOS && isWebKit && !isSafari;
  },
};
